declare global {
    interface Window {
        __rcds_portal: {
            SSO_CLIENT_ID: string;
            SSO_AUTHORITY: string;
            API_URI: string;
            APPINSIGHTS_INSTRUMENTATIONKEY: string;
        };
    }
}

const SSO_CLIENT_ID = window.__rcds_portal.SSO_CLIENT_ID;
const SSO_AUTHORITY = window.__rcds_portal.SSO_AUTHORITY;
const API_URI = window.__rcds_portal.API_URI;
const APPINSIGHTS_INSTRUMENTATIONKEY =
    window.__rcds_portal.APPINSIGHTS_INSTRUMENTATIONKEY;

export {
    SSO_CLIENT_ID,
    SSO_AUTHORITY,
    API_URI,
    APPINSIGHTS_INSTRUMENTATIONKEY
};
